var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-divider',{staticClass:"my-3"}),_c('p',{staticClass:"text-center primary--text mb-0"},[_vm._v("\n    Resultados 1 a "+_vm._s(_vm.length)+" de\n    "+_vm._s(_vm.total)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }